const smtStepperComponent = {
  item: {
    vr: {
      bgColor: {
        default: 'gray.200',
        _dark: 'gray.700'
      }
    },
    icon: {
      wrapper: {
        bgColor: {
          default: 'gray.200',
          _dark: 'gray.700'
        }
      },
      color: {
        default: 'gray.500',
        _dark: 'gray.400'
      }
    }
  }
};

export default smtStepperComponent;
